export default from './login-page';



// WEBPACK FOOTER //
// ./app/containers/login-page/index.js